import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import HeroSection from './components/HeroSection';
import SearchBar from './components/SearchBar';
import ViewAllPeptidesBlock from './components/ViewAllPeptidesBlock';
import PeptidesByCategory from './components/PeptidesByCategory';

const Homepage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>INF LABS - Premium Peptides for Performance & Recovery</title>
        <meta 
          name="description" 
          content="Discover premium peptides from INF LABS including Tirzepatide, Retatrutide, BPC-157, and more. Fast shipping and secure PayPal payment." 
        />
        <meta name="keywords" content="peptides, Tirzepatide, Retatrutide, BPC-157, weight management, performance enhancement, INF LABS" />
      </Helmet>

      <div className="min-h-screen bg-[var(--color-background)]">
        <Header />
        
        <main className="pt-[80px]">
          <HeroSection />
          <div className="px-4 sm:px-6 md:px-8">
            <SearchBar />
          </div>
          <div className="space-y-8 sm:space-y-12 md:space-y-16">
            <ViewAllPeptidesBlock />
            <PeptidesByCategory />
          </div>
        </main>
      </div>
    </>
  );
};

export default Homepage;